// extracted by mini-css-extract-plugin
export default {"card":"k8Uiy7PU","name":"_oFI65zf","jobTitle":"YrHR_VzF","imageContainer":"dN2NI0eM","quoteSign":"darJDRaj","quoteTextContainer":"bziKjzQ6","mobile":"mobile","quoteText":"Vg807HqT"};